// Formats a date to YYYY-MM-DD
export const formatNaiveDate = (date: string): string => {
    // we simply split off the time part
    return new Date(date).toISOString().split('T')[0];
};
